import { explainerLeftBackground, explainerBackgroundIcons } from 'resources/images'

import { LeftSideBackground, ImageIconContainer, FeaturedImageAlignedBottom } from './styles'

const ExplainerWithIconsComponent = () => (
  <ImageIconContainer>
    <LeftSideBackground background={explainerLeftBackground} />
    <FeaturedImageAlignedBottom src={explainerBackgroundIcons} />
  </ImageIconContainer>
)

export default ExplainerWithIconsComponent
